
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTA() {
  const { t } = useTranslation('common');

  return (
    <section className="relative py-24 px-4 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/df78eb897cdc2f057cf74e94ebd6e39a.jpg')] opacity-10 bg-cover bg-center"></div>
      
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-400/20 rounded-full blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {t('cta.title')}
        </h2>
        <p className="text-xl text-gray-700 mb-8">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/dashboard"
          className="inline-block px-8 py-4 bg-white text-teal-600 rounded-lg font-bold text-lg hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          {t('cta.button')}
        </Link>
        <p className="text-sm text-gray-600 mt-6">
          {t('cta.noCreditCard')}
        </p>
      </div>
    </section>
  );
}
